import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Navigation.svg",
  "use": "Navigation.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Navigation.svg\"><path d=\"M32.0105,56.0206a24,24,0,1,1,24-24A24,24,0,0,1,32.0105,56.0206ZM42.9229,43.2243l-9.65-25.3476a1.3619,1.3619,0,0,0-2.5309,0l-9.65,25.3476a1.34,1.34,0,0,0,2.034,1.5415l8.1129-5.48a1.3782,1.3782,0,0,1,1.5371,0l8.113,5.48A1.34,1.34,0,0,0,42.9229,43.2243Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol